import * as React from "react";
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import CartRepository from "../../../repository/CartRepository";
import ListingBeforeAddToCart from "./InventoryAlertPopup/ListingBeforeAddToCart";
import useReduxState from "../../../hooks/useReduxState";
import store from "src/storeWire";
import { SET_ADD_CART_DATA } from "src/store/slice/model/Cart";
import { useCartStore } from "src/hooks/cart";
import { useProductInventoryStore } from "src/hooks/productInventory";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import { useProductPricingStore } from "src/hooks/productPricing";
import Constants from "src/support/Constants";

const InventoryAlertForAddToCartPopup = (props) => {
  const [status, SetStatus] = useState(false);
  const [products, SetProducts] = useState([]);
  const [, setProductSelected] = useReduxState(
    {},
    "setAutoCompleteProductSelected"
  );
  const [searchTerm, setSearchTerm] = useReduxState(
    "",
    "setAutoCompleteSearchTerm"
  );
  const [{ InventoryAlertForAddToCartPopup }, {}, {}] =
    useDOMAttachToSystemStore();
  const [, { get_inventory_by_id }, {}] = useProductInventoryStore();
  const [{}, {}, { replace_cart_in_Bulk }] = useCartStore();
  const [load, SetLoad] = useState(false);
  const [{ pricingList }, {}, {}] = useProductPricingStore();

  useEffect(() => {
    if (InventoryAlertForAddToCartPopup) {
      let single_product = JSON.parse(
        JSON.stringify(InventoryAlertForAddToCartPopup.data)
      );
      SetProducts([{ ...single_product }]);
      SetStatus(true);
    }
  }, [InventoryAlertForAddToCartPopup]);
  const onHide = (action = true) => {
    SetStatus(false);
    if (action) {
      store.dispatch(SET_ADD_CART_DATA(false));
    }
  };
  const getProductInventoryQuantityByERPPartNumber = (ERPPartNumber) => {
    let inventoryResult = getInventory(ERPPartNumber);
    if (
      inventoryResult !== undefined &&
      inventoryResult !== null &&
      inventoryResult.quantity !== undefined &&
      inventoryResult.quantity > 0
    ) {
      return inventoryResult.quantity;
    }
    return 0;
  };
  const getProductInventoryLeadTimeByERPPartNumber = (ERPPartNumber) => {
    if (
      ERPPartNumber === undefined ||
      ERPPartNumber === null ||
      ERPPartNumber === ""
    ) {
      return "";
    }
    let inventoryResult = getInventory(ERPPartNumber);
    if (
      inventoryResult !== undefined &&
      inventoryResult !== null &&
      inventoryResult.plifz !== undefined &&
      inventoryResult.plifz !== ""
    ) {
      return inventoryResult.plifz;
    }
    return "Not Available";
  };

  //added by Ramya [Adobe script]
  const getInventory = (ERPPartNumber) => {
    return get_inventory_by_id(ERPPartNumber)
  };
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };
  return (
    <>
      <Modal
        show={status}
        onHide={() => {
          onHide();
        }}
      >
        <div className="avnet-modal modal-680">
          <div className="avnet-modal-inner">
            {/* Modal Header */}
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => {
                onHide();
              }}
            >
              ×
            </button>
            <div className="modal-header justify-content-center mt-0">
              <h3 className="pcn-modal-heading">Inventory Alert</h3>
            </div>
            <div className="m-4 mt-0">
              <div className="justify-content-start">
                We currently do not have sufficient inventory for the following
                items in your cart. <br />
                Would you like to place backorder for these items?
              </div>
            </div>
            <div className="modal-body">
              <div className="inventory-table">
                <ListingBeforeAddToCart
                  PRODUCTS_DATA={products}
                  getProductInventoryQuantityByERPPartNumber={(
                    ERPPartNumber
                  ) => {
                    return getProductInventoryQuantityByERPPartNumber(
                      ERPPartNumber
                    );
                  }}
                  getProductInventoryLeadTimeByERPPartNumber={(
                    ERPPartNumber
                  ) => {
                    return getProductInventoryLeadTimeByERPPartNumber(
                      ERPPartNumber
                    );
                  }}
                />
              </div>
            </div>
            {/* Modal footer */}
            <div className="modal-footer justify-content-center">
              <div className="modal-footer-actions">
                <button
                  type="button"
                  className="bs5 btn btn-secondary btn-sm w145"
                  disabled={load}
                  data-bs-toggle="modal"
                  data-bs-target="#InventoryModal"
                  onClick={() => {
                    onHide();
                  }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="bs5 btn btn-primary btn-sm w145"
                  onClick={async (e) => {
                    if (load) {
                      e.preventDefault();
                      return false;
                    }
                    SetLoad(true);
                    products.map(async (v, i) => {
                      /**
                       * If isReplaceCart true then call replace cart item other wise add to cart item
                       * Author: Devanshi Patel
                       */
                      if (props.data.isReplaceCart) {
                        await replace_cart_in_Bulk(v);
                      } else {
                        /**
                         * isManuallyAddCart is used for confirm it from manually add cart or normal cart
                         * Author: Devanshi Patel
                         */
                        let param = {
                          partNumber: v.ERPPartNumber,
                          assetURL: v.assetURL,
                          ItemNumber: v.ItemNumber,
                          ManufacturerPartNumber: v.ManufacturerPartNumber,
                          ERPMFRPartNumber: v.ERPMFRPartNumber,
                          quantity: v.quantity,
                          totalQuantity: v.totalQuantity, //added
                          backOrderQuantity: v.backOrderQuantity,
                          subtotal: v.subtotal,
                          manufacturerCode: v.ManufacturerCode,
                          manufacturerName: v.ManufacturerName,
                          erpManufacturerCode: v.ERPManufacturerCode,
                          erpManufacturerName: v.ERPManufacturerName,
                          cpn: v.cpn,
                          cpnType:
                            v?.CustomerPartNumbers?.length > 0
                              ? Constants.cpnTypes.CPN
                              : Constants.cpnTypes.MANUALCPN,
                          manualCPN: "",
                          vendorCode: v?.VendorCode,
                          sapMatGroup: v?.SAPMatgroup,
                          ERPSupplierCode: v?.ERPSupplierCode, //added by Ramya
                          qas:getInventory(v?.ERPPartNumber).qas, //added by Ramya
                          priceSource:getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)[0].priceSource, //added by Ramya
                          hazardousFlag: v?.hazardousFlag
                        };
                        // if (param.cpnType === Constants.cpnTypes.MANUALCPN) {
                        // param.manualCPN = ''
                        // }
                        await new CartRepository().addToCartServer(
                          param,
                          props.data.isManuallyAddCart,
                          props.data?.isFrom
                        );
                        if (
                          props.data.productAddedToCartCallback !== undefined
                        ) {
                          props.data.productAddedToCartCallback();
                        }
                        if (props.data?.isFrom) {
                          /**
                           * Set Events and Evars as per basav comment (14664)
                           * Author: Devanshi Patel
                           */
                          if (window?.digitalData) {
                            if (!window?.digitalData?.transaction) {
                              window.digitalData.transaction = {};
                            }
                            window.digitalData.event.eventinfo.events =
                              "Add to Cart clicked from " + props.data?.isFrom;
                            window.digitalData.transaction.items =
                              v?.ERPMFRPartNumber;
                          }
                        }
                      }

                      setProductSelected({});
                      setSearchTerm("");
                      if (i == products?.length - 1) {
                        SetLoad(false);
                      }
                    });
                    // onHide(false);
                  }}
                >
                  {load && <i className="fa fa-spinner fa-spin" />}
                  {!load && <>Yes</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default InventoryAlertForAddToCartPopup;
